import classNames from 'classnames'
import { useRouter } from 'next/router'
import BSCard from 'react-bootstrap/Card'

import Spinner from '@/components/Spinner/Spinner'
import { CommanderPageProps } from '@/types/page'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'
import NavigationPanelBudget from './NavigationPanelBudget'
import NavigationPanelPartners from './NavigationPanelPartners'
import NavigationPanelTags from './NavigationPanelTags'
import NavigationPanelTop from './NavigationPanelTop'

type Props = {
  data: CommanderPageProps['data']
}

const NavigationPanel = ({ data }: Props) => {
  const { subsubpage, subsubsubpage } = useDirectories()
  const router = useRouter()
  const card = data.container.json_dict.card

  if (!card) {
    return (
      <BSCard className={classNames(styles.navigation, 'justify-content-center shadow-sm')}>
        <Spinner className='fa-2x' />
      </BSCard>
    )
  }

  if (router.asPath.startsWith('/cards') && !card.legal_commander && !card.type.includes('Background')) {
    return null
  }

  const budget = ['budget', 'expensive'].includes(subsubpage)
    ? subsubpage
    : ['budget', 'expensive'].includes(subsubsubpage)
      ? subsubsubpage
      : undefined
  const tag = ['budget', 'expensive'].includes(subsubpage) ? undefined : subsubpage

  const tagLinks = data.panels?.taglinks
  const hasBudget =
    !router.query.tag ||
    ['budget', 'expensive'].includes(router.query.tag as string) ||
    (tagLinks?.find((tagLink) => tagLink['slug'] === `${router.query.tag}`)?.count || 0) > 9

  return (
    <BSCard
      className={classNames(styles.navigation, 'shadow-sm', {
        'justify-content-start': tagLinks?.length === 0,
      })}
    >
      <NavigationPanelTop budget={budget} card={card} tag={tag} />
      {tagLinks ? (
        <>
          <NavigationPanelBudget budget={budget} disabled={!hasBudget} sanitized_wo={card.sanitized_wo} tag={tag} />
          <NavigationPanelTags budget={budget} sanitized_wo={card.sanitized_wo || ''} tag={tag} tags={tagLinks} />
        </>
      ) : (
        data.partnercounts && <NavigationPanelPartners partnercounts={data.partnercounts} />
      )}
    </BSCard>
  )
}

export default NavigationPanel
